import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";

function useWarehouseDetailDistribution(params) {
  return useSWR(
    !params?.id
      ? null
      : {
          path: `/api/v1/warehouses/${params?.id}/distribution`,
          method: "GET",
          params,
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWarehouseDetailDistribution;
